import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Form, Row, Button } from 'react-bootstrap';
import logoCenec from './assets/cenec_2.svg';
import logoChorotega from './assets/chorotega_2.svg';
import { useForm } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { SpinnerLoader } from './components/Spinner';
import { TransactionDetail } from './components/TransactionDetail';
import { directSale } from './pixelpay/pixelpay';
import { NotFound } from './components/NotFound';
import countries from '@pixelpay/sdk-core/lib/assets/countries.json'
import states from '@pixelpay/sdk-core/lib/assets/states.json'
import phoneCode from '@pixelpay/sdk-core/lib/assets/formats.json'
import { CreditCard, ShieldCheck, PinMap, GlobeAmericas, Person, CashStack } from 'react-bootstrap-icons';

const baseUrl = process.env.REACT_APP_API_URL
const procotol = process.env.REACT_APP_API_PROTOCOL

export const OpenPaymentLink = () => {

    const { slug } = useParams();
    const [stateSelect, setStateSelect] = useState({})
    const [phoneCodeSelected, setPhoneCodeSelected] = useState(null)
    const [isInternational, setIsInternational] = useState(false);
    const [showBillingAddress, setShowBillingAddress] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [validateEntrepreneur, setValidateEntrepreneur] = useState(null);
    const [detailData, setDetailData] = useState(null)
    const [showTransactionDetail, setShowTransactionDetail] = useState(false)
    const [trasactionDetailData, setTrasactionDetailData] = useState(null)
    const [isPosting, setIsPosting] = useState(false);
    const { register, handleSubmit, formState: { errors }, watch } = useForm();
    watch(["country"])
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    const currentYear = new Date().getFullYear()
    const maxYear = currentYear + 20;
    let years = [];

    for (let i = currentYear; i <= maxYear; i++) {
        years.push(i);
    }

    useEffect(() => {
        async function fnValidateEntrepreneur(slug) {
            try {
                setIsLoading(true);
                const url = `${procotol}//${baseUrl}/administration/api/validate-entrepreneur/${slug}/`;
                const res = await axios.get(url);
                setValidateEntrepreneur(res.data)
            } catch (err) {
                const { response } = err
                setValidateEntrepreneur(response.data)
            }
            finally {
                setIsLoading(false)
            }
        }
        fnValidateEntrepreneur(slug)
    }, [slug])


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === 'country') {
                if (!!value.country) {
                    setStateSelect(states[value.country])
                    setPhoneCodeSelected(`+${phoneCode[value.country].phone_code}`);
                } else {
                    setStateSelect({})
                    setPhoneCodeSelected(null)
                }
            }
        })

        return () => subscription.unsubscribe()
    }, [watch])

    // Cuando cambie a internacional, activar checkbox de facturación
    useEffect(() => {
        if (isInternational) {
            setShowBillingAddress(true);
        }
    }, [isInternational])


    const onSubmit = async (data) => {
        try {
            setIsPosting(true);
            data = {
                ...data,
                number: data.number.replaceAll(' ', '')
            }
            const id = validateEntrepreneur.id
            const urlStartTransc = `${procotol}//${baseUrl}/administration/api/start-transaction/${slug}/${id}/`;
            let startTranscData = {
                email: data.email,
                cardholder: data.cardholder,
                amount: data.amount,
            }

            if (!isInternational && !showBillingAddress) {
                data.country = "HN";
                data.state = "HN-FM";
                data.city = "Tegucigalpa";
                data.address = "Tegucigalpa";
                data.phone = "94043476";
                data.zip = "11101";
            }

            const resStartTrans = await axios.post(urlStartTransc, startTranscData);
            const res = await directSale(data, resStartTrans.data.correlative, resStartTrans.data.email, validateEntrepreneur.name)
            if (res.success) {
                setTrasactionDetailData(res)
                setDetailData({
                    correlative: resStartTrans.data.correlative,
                    number: data.number.slice(-4),
                    ...startTranscData,
                })
                setShowTransactionDetail(true)
            } else {
                Swal.fire(
                    'Algo no salió bien!',
                    `${res.message}`,
                    'error'
                )
            }


        } catch (err) {
            const { response } = err
            Swal.fire(
                'Algo no salió bien!',
                `${response?.data?.msg}`,
                'error'
            )
        }
        finally {
            setIsPosting(false)
        }
    }

    if (isLoading) {
        return <SpinnerLoader />
    }
    if (validateEntrepreneur?.status === 'error') {
        return <NotFound />
    }

    // Determinar si mostrar los campos adicionales
    const showAdditionalFields = isInternational || showBillingAddress;

    return (
        <>
            {
                showTransactionDetail
                    ? <TransactionDetail
                        data={trasactionDetailData}
                        entrepreneur={validateEntrepreneur}
                        detailData={detailData}
                    />
                    :
                    <Container className='' style={{ 'maxWidth': '800px' }} >
                        <div className='d-flex justify-content-center mb-3 ms-2 me-2'>
                            <Card className='card-custom-style '>
                                <Card.Header className='white-bg-color'>
                                    <Row>
                                        <Col md={12} className='d-flex align-items-center justify-content-center'>
                                            {
                                                validateEntrepreneur?.logo
                                                    ? <img
                                                        src={`${procotol}//${baseUrl}/${validateEntrepreneur.logo}`}
                                                        alt={`${validateEntrepreneur?.entrepreneurship_name} logo`}
                                                        className='w-50'
                                                    />
                                                    : <h1 className={`text-center h3 m-0`}>{validateEntrepreneur?.entrepreneurship_name}</h1>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <Row className='justify-content-center'>
                                            <Col md='10'>
                                                {
                                                    validateEntrepreneur?.logo && <h1 className={`text-center h3 m-0`}>{validateEntrepreneur.entrepreneurship_name}</h1>
                                                }
                                                <p className='fw-bold mt-4'>{validateEntrepreneur?.description}</p>

                                            </Col>

                                            <Col md='5' sm='6' className='mb-3'>
                                                <Button
                                                    type="button"
                                                    variant={!isInternational ? 'success' : 'secondary'}
                                                    size="lg"
                                                    className="w-100 d-flex align-items-center justify-content-center"
                                                    onClick={() => setIsInternational(false)}
                                                >
                                                    <PinMap className='me-2' />
                                                    Nacional
                                                </Button>
                                            </Col>
                                            <Col md='5' sm='6' className='mb-3'>
                                                <Button
                                                    type="button"
                                                    variant={isInternational ? 'success' : 'secondary'}
                                                    size="lg"
                                                    className="w-100 d-flex align-items-center justify-content-center"
                                                    onClick={() => setIsInternational(true)}
                                                >
                                                    <GlobeAmericas className='me-2' />
                                                    Extranjero
                                                </Button>
                                            </Col>

                                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                                <div className="input-group">
                                                    <span className='input-group-text'><CreditCard /></span>
                                                    <div className="form-floating">
                                                        <ReactInputMask
                                                            type='text'
                                                            mask={"9999 9999 9999 9999"}
                                                            maskChar={" "}
                                                            id='idNumberCard'
                                                            placeholder='Número de tarjeta'
                                                            className='form-control'
                                                            {...register('number',
                                                                {
                                                                    required: 'Número de tarjeta es requerido'
                                                                }
                                                            )}
                                                        />
                                                        <label htmlFor="idNumberCard" className='text-muted'>Número de tarjeta</label>
                                                    </div>
                                                </div>
                                                {errors.number && <p className="text-danger">{errors.number.message}</p>}
                                            </Col>

                                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                                <div className="input-group">
                                                    <span className='input-group-text'><Person /></span>
                                                    <div className="form-floating">
                                                        <Form.Control
                                                            type='text'
                                                            id='idCustomerName'
                                                            placeholder='Juan Perez'
                                                            {...register(
                                                                "cardholder",
                                                                {
                                                                    required: 'Nombre del titular de la tarjeta es requerido'
                                                                }
                                                            )}
                                                        />
                                                        <label htmlFor="idCustomerName" className='text-muted'>Nombre del titular de la tarjeta</label>
                                                    </div>
                                                </div>
                                                {errors.cardholder && <p className="text-danger">{errors.cardholder.message}</p>}
                                            </Col>

                                            <Col md='5' sm='12' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectMonth"
                                                        aria-label="Seleccione"
                                                        {...register('expire_month',
                                                            {
                                                                required: 'Mes es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione</option>
                                                        {
                                                            months.map(item => (<option key={`mesExperira${item}`} value={item}>{item}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectMonth">Mes vencimiento</label>
                                                </div>
                                                {errors.expire_month && <p className="text-danger">{errors.expire_month.message}</p>}
                                            </Col>

                                            <Col md='5' sm='12' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectYear"
                                                        aria-label="Selecciona"
                                                        {...register('expire_year',
                                                            {
                                                                required: 'Año es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione</option>
                                                        {
                                                            years.map(item => (<option key={`añoExperira${item}`} value={item}>{item}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectYear">Año vencimiento</label>
                                                </div>
                                                {errors.expire_year && <p className="text-danger">{errors.expire_year.message}</p>}
                                            </Col>

                                            <Col md='5' sm='6' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='number'
                                                        id='idCVVCustomer'
                                                        placeholder=''
                                                        {...register(
                                                            "cvv2",
                                                            {
                                                                required: 'CVV es campo requerido'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idCVVCustomer" className='text-muted'>CVV</label>
                                                </div>
                                                {errors.cvv2 && <p className="text-danger">{errors.cvv2.message}</p>}
                                            </Col>

                                            <Col md='5' sm='6' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='email'
                                                        id='idEmailCustomer'
                                                        placeholder='correo@electroni.co'
                                                        {...register(
                                                            "email",
                                                            {
                                                                required: 'Correo electrónico es requerido'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idEmailCustomer" className='text-muted'>Correo electrónico</label>
                                                </div>
                                                {errors.email && <p className="text-danger">{errors.email.message}</p>}
                                            </Col>

                                            <Col md='10' sm='12' xs='12' className=' mb-3'>
                                                <div className="input-group">
                                                    <span className='input-group-text'>L. </span>
                                                    <div className="form-floating">
                                                        <Form.Control
                                                            type='number'
                                                            id='idAmount'
                                                            className='fw-bold'
                                                            placeholder='Monto a pagar'
                                                            {...register(
                                                                "amount",
                                                                {
                                                                    required: 'Monto a pagar es requerido'
                                                                }
                                                            )}

                                                        />
                                                        <label htmlFor="idAmount" className='text-muted'>Monto a pagar</label>
                                                    </div>
                                                </div>
                                                {errors.amount && <p className="text-danger">{errors.amount.message}</p>}
                                            </Col>

                                            {/* Checkbox de facturación - Solo visible si NO es internacional */}
                                            {!isInternational && (
                                                <Col md='10' sm='12' xs='12' className=' mb-3'>
                                                    <div className="form-check mb-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="needInvoice"
                                                            checked={showBillingAddress}
                                                            onChange={(e) => setShowBillingAddress(e.target.checked)}
                                                        />
                                                        <label className="form-check-label" htmlFor="needInvoice">
                                                            Deseo ingresar dirección de facturación
                                                        </label>
                                                    </div>
                                                </Col>
                                            )}

                                            {/* Campos adicionales - Se muestran tanto para internacional como para facturación */}
                                            {showAdditionalFields && (
                                                <>
                                                    <Col md='10' className='mb-3'>
                                                        <Card className={`border-${isInternational ? 'primary' : 'success'} bg-light`}>
                                                            <Card.Body>
                                                                <h5 className={`text-${isInternational ? 'primary' : 'success'} mb-3`}>
                                                                    {isInternational ? 'Información Extranjero' : 'Datos de Facturación'}
                                                                </h5>

                                                                <Row>
                                                                    <Col md={6} className='mb-3'>
                                                                        <div className="form-floating">
                                                                            <Form.Select
                                                                                id='idCountry'
                                                                                {...register('country', {
                                                                                    required: showAdditionalFields ? 'País es requerido' : false
                                                                                })}
                                                                            >
                                                                                <option value="">Seleccione un país</option>
                                                                                {Object.keys(countries).map(key => (
                                                                                    <option key={key} value={key}>
                                                                                        {countries[key]}
                                                                                    </option>
                                                                                ))}
                                                                            </Form.Select>
                                                                            <label htmlFor="idCountry">País</label>
                                                                        </div>
                                                                        {errors.country && <p className="text-danger">{errors.country.message}</p>}
                                                                    </Col>

                                                                    <Col md={6} className='mb-3'>
                                                                        <div className="form-floating">
                                                                            <Form.Select
                                                                                id='idState'
                                                                                {...register('state', {
                                                                                    required: showAdditionalFields ? 'Estado es requerido' : false
                                                                                })}
                                                                                disabled={Object.keys(stateSelect).length === 0}
                                                                            >
                                                                                <option value="">Seleccione un estado</option>
                                                                                {Object.keys(stateSelect).map(key => (
                                                                                    <option key={key} value={key}>
                                                                                        {stateSelect[key]}
                                                                                    </option>
                                                                                ))}
                                                                            </Form.Select>
                                                                            <label htmlFor="idState">Estado</label>
                                                                        </div>
                                                                        {errors.state && <p className="text-danger">{errors.state.message}</p>}
                                                                    </Col>

                                                                    <Col md={12} className='mb-3'>
                                                                        <Form.Control
                                                                            type='text'
                                                                            placeholder='Ciudad'
                                                                            {...register('city', {
                                                                                required: showAdditionalFields ? 'Ciudad es requerida' : false
                                                                            })}
                                                                        />
                                                                        {errors.city && <p className="text-danger">{errors.city.message}</p>}
                                                                    </Col>

                                                                    <Col md={12} className='mb-3'>
                                                                        <Form.Control
                                                                            type='text'
                                                                            placeholder='Dirección'
                                                                            {...register('address', {
                                                                                required: showAdditionalFields ? 'Dirección es requerida' : false
                                                                            })}
                                                                        />
                                                                        {errors.address && <p className="text-danger">{errors.address.message}</p>}
                                                                    </Col>

                                                                    <Col md={6} className='mb-3'>
                                                                        <div className='input-group'>
                                                                            <span className='input-group-text'>{phoneCodeSelected}</span>
                                                                            <Form.Control
                                                                                type='tel'
                                                                                placeholder='Número de teléfono'
                                                                                {...register('phone', {
                                                                                    required: showAdditionalFields ? 'Teléfono es requerido' : false
                                                                                })}
                                                                            />
                                                                        </div>
                                                                        {errors.phone && <p className="text-danger">{errors.phone.message}</p>}
                                                                    </Col>

                                                                    <Col md={6} className='mb-3'>
                                                                        <Form.Control
                                                                            type='text'
                                                                            placeholder='Código postal'
                                                                            {...register('zip', {
                                                                                required: showAdditionalFields ? 'Código postal es requerido' : false
                                                                            })}
                                                                        />
                                                                        {errors.zip && <p className="text-danger">{errors.zip.message}</p>}
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </>
                                            )}

                                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                                <p className='text-muted'>Los cobros se realizarán en moneda HNL, aunque la tarjeta sea en una moneda diferente.</p>
                                            </Col>
                                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        variant="primary"
                                                        size="lg"
                                                        type="submit"
                                                        disabled={isPosting}
                                                        className="p-3 chorotega-bg-color"
                                                    >
                                                        <ShieldCheck className="me-2" />
                                                        {isPosting ? 'PROCESANDO...' : 'REALIZAR PAGO'}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                                <Card.Footer className='white-bg-color'>
                                    <Row className='justify-content-center'>
                                        <Col md={10}>
                                            <Row className='justify-content-center chorotega-bg-color mx-1 p-3 rounded-1 mb-3 mt-3'>
                                                <Col xl={5} md={5} sm={5} xs={12} className='order-last order-sm-first order-md-first' >
                                                    <div className='d-flex justify-content-center align-items-center'>
                                                        <img src={logoCenec} alt="Logo CENEC" className='img-cenec' />
                                                    </div>
                                                </Col>
                                                <Col xl={2} md={2} sm={2} className='d-none d-sm-block text-center'>
                                                    <div className='vl'></div>
                                                </Col>
                                                <Col xs={12} className='d-block d-sm-none'>
                                                    <div className='hl'></div>
                                                </Col>
                                                <Col xl={5} md={5} sm={5} xs={12} className='order-first order-sm-last order-md-last' >
                                                    <div className='d-flex justify-content-center align-items-center'>
                                                        <img src={logoChorotega} alt="Logo Cooperativa Chorotega" className='img-owner' />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Footer>
                            </Card>
                        </div>
                    </Container>
            }
        </>
    )
}